import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { Store, select } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { LocationAvailabilityEnum } from "src/app/shared/enum/location-availability";
import {
  ObjectiveTypeEnum,
  ObjectiveTypeEnumMapping,
} from "src/app/shared/enum/objectives";
import { AdDetailsInterface } from "src/app/shared/models/advertising-campaigns/ad-details.interface";
import {
  TotalPrice,
  TotalPriceWithDiscount,
} from "src/app/shared/models/calcul/totalPrice";
import { FilterLocationPartnersToCreateCampaign } from "src/app/shared/models/location-partners/filterBySubCategoriesAndTagLocationPartner";
import { BadgeService } from "src/app/shared/services/badge.service";
import { adDetailsSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import { AppStateInterface } from "src/app/store/appState.interface";
import { invokeLocationsToCreateCampaign } from "src/app/store/locationPartner/actions/get-locations.actions";
import { initialState as locationInitialState } from "src/app/store/locationPartner/location-partner.reducers";
import {
  locationPartnersToCreateCampaignFilterSelector,
  calculateTotalLPPriceByCampanyNamesSelector,
} from "src/app/store/locationPartner/location-partner.selectors";
import { NewCampaignCalculatorService } from "src/app/shared/services/calculations/new-campaign.service";
import { initialState as adsInitialState } from "src/app/store/advertisingCampaign/advertisingCampaign.reducers";
import { JwtService } from "src/app/shared/services/jwt.service";
import { RoleEnum } from "src/app/shared/models/user/role.interface";
import { invokeAllActivatedAdvertisers } from "src/app/store/advertiser/advertiser.actions";
import { AdvertiserDetailsInterface } from "src/app/shared/models/advertiser/profile.interface";
import { advertisersSelector } from "src/app/store/advertiser/advertiser.selectors";
import { UtilFunctions } from "src/app/utils/utilFunctions";
@Component({
  selector: "app-step1",
  templateUrl: "./step1.component.html",
  styleUrls: ["./step1.component.scss"],
})
export class Step1Component extends BaseComponent implements OnInit {
  Math = Math;
  castString(input: any[]): string {
    return Array.isArray(input)
      ? input
          .map((item) => {
            return String(item);
          })
          .join(", ")
      : "";
  }

  active = 1;
  @Input() form: FormGroup;
  @Input() objectiveName: ObjectiveTypeEnum;
  localStoreObjective: ObjectiveTypeEnum =
    ObjectiveTypeEnum.LOCAL_STORE_PROMOTIONS;

  //Dates
  objectiveTypeEnum = ObjectiveTypeEnum;
  objectiveTypeEnumMapping = ObjectiveTypeEnumMapping;

  totalPricePerDay: string;
  impressionsPerDay: number = 0;

  adDetails$: Observable<AdDetailsInterface>;

  adDetails: AdDetailsInterface = adsInitialState.adDetails;

  calculateTotalLPPriceByCampanyNames$: Observable<TotalPriceWithDiscount | null>;
  calculateTotalLPPriceByCampanyNames: TotalPrice[] = [];
  selectedLocationsNames: string[] = [];

  locationPartnersToCreateCampaignFilter$: Observable<FilterLocationPartnersToCreateCampaign>;
  locationPartnersToCreateCampaignFilter: FilterLocationPartnersToCreateCampaign =
    {
      ...locationInitialState.locationPartnersToCreateCampaignFilter,
    };
  allSelectionsByMethod: string[] = [];

  showAllLocations: boolean = false;

  animating: boolean = false;

  totalImpressionsMin: number = 0;
  totalImpressionsMax: number = 0;

  totalClicksMin: number = 0;
  totalClicksMax: number = 0;

  totalLeadsMin: number = 0;
  totalLeadsMax: number = 0;

  prevTotalImpressionsMin: number = 0;
  prevTotalImpressionsMax: number = 0;

  prevTotalClicksMin: number = 0;
  prevTotalClicksMax: number = 0;

  prevTotalLeadsMin: number = 0;
  prevTotalLeadsMax: number = 0;

  newTotalImpressionsMin: number = 0;
  newTotalImpressionsMax: number = 0;

  newTotalClicksMin: number = 0;
  newTotalClicksMax: number = 0;

  newTotalLeadsMin: number = 0;
  newTotalLeadsMax: number = 0;

  totalPrice: string;

  animationInterval: NodeJS.Timer;
  startDate: Date;
  endDate: Date;

  roleName: string;
  roleEnum = RoleEnum;
  activatedAdvertisers$: Observable<AdvertiserDetailsInterface[] | null>;
  activatedAdvertisers: AdvertiserDetailsInterface[];
  constructor(
    private store: Store<AppStateInterface>,
    public badgeService: BadgeService,
    private newCampaignCalculatorService: NewCampaignCalculatorService,
    private jwtService: JwtService
  ) {
    super(store);
    this.adDetails$ = this.store
      .pipe(select(adDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.locationPartnersToCreateCampaignFilter$ = this.store
      .pipe(select(locationPartnersToCreateCampaignFilterSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.calculateTotalLPPriceByCampanyNames$ = this.store
      .pipe(select(calculateTotalLPPriceByCampanyNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.activatedAdvertisers$ = this.store
      .pipe(select(advertisersSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.roleName = jwtService.getRoleName(jwtService.getToken());
  }

  ngOnInit(): void {
    this.adDetails$.subscribe((result: AdDetailsInterface) => {
      this.adDetails = result;
      this.impressionsPerDay = result.impressionsPerDay ?? 0;
      this.totalPricePerDay = result.totalPricePerDay.toFixed(3) ?? 0;

      this.totalPrice = result.totalPrice.toFixed(3) ?? 0;
      if (this.adDetails.locations.length == 0)
        this.selectedLocationsNames = [];

      this.prevTotalImpressionsMin = this.newTotalImpressionsMin;
      this.prevTotalImpressionsMax = this.newTotalImpressionsMax;

      this.prevTotalClicksMin = this.newTotalClicksMin;
      this.prevTotalClicksMax = this.newTotalClicksMax;

      this.prevTotalLeadsMin = this.newTotalLeadsMin;
      this.prevTotalLeadsMax = this.newTotalLeadsMax;

      this.newTotalImpressionsMin = Math.ceil(
        this.adDetails.totalImpressions * 0.95
      );
      this.newTotalImpressionsMax = Math.ceil(
        this.adDetails.totalImpressions * 1.05
      );

      this.newTotalClicksMin = Math.ceil(this.adDetails.totalClicks.min);
      this.newTotalClicksMax = Math.ceil(this.adDetails.totalClicks.max);

      this.newTotalLeadsMin = Math.ceil(this.adDetails.totalLead.min);
      this.newTotalLeadsMax = Math.ceil(this.adDetails.totalLead.max);

      clearInterval(this.animationInterval);

      this.totalImpressionsMin = this.prevTotalImpressionsMin;
      this.totalImpressionsMax = this.prevTotalImpressionsMax;

      this.totalClicksMin = this.prevTotalClicksMin;
      this.totalClicksMax = this.prevTotalClicksMax;

      this.totalLeadsMin = this.prevTotalLeadsMin;
      this.totalLeadsMax = this.prevTotalLeadsMax;

      this.playAnimation();
    });

    this.locationPartnersToCreateCampaignFilter$.subscribe(
      (result: FilterLocationPartnersToCreateCampaign) => {
        if (
          result.locationsSearchMethod != null &&
          result.regions?.length > 0
        ) {
          this.store.dispatch(invokeLocationsToCreateCampaign());
          this.locationPartnersToCreateCampaignFilter = result;
        }
      }
    );

    this.calculateTotalLPPriceByCampanyNames$.subscribe(
      (value: TotalPriceWithDiscount | null) => {
        if (value != null) {
          this.allSelectionsByMethod = value.totalPricePerDay.map(
            (lp) => lp.companyName
          );
          this.calculateTotalLPPriceByCampanyNames =
            value.totalPricePerDay.filter(
              (lp: TotalPrice) =>
                lp.availabilities.availabilityStatus !=
                LocationAvailabilityEnum.NOT_AVAILABLE
            );
          this.selectedLocationsNames =
            this.calculateTotalLPPriceByCampanyNames.map(
              (location) => location.companyName
            );
        }
      }
    );

    this.form.valueChanges.subscribe((data) => {
      if (data.startingDate && data.endingDate) {
        this.startDate = new Date(data.startingDate);
        this.endDate = new Date(data.endingDate);
      }
    });

    if (this.roleName === RoleEnum.ROLE_ADMIN) {
      this.store.dispatch(invokeAllActivatedAdvertisers());
      this.form.get("advertiser")?.setValidators([Validators.required]);
    } else {
      this.form.get("advertiser")?.clearValidators();
    }

    this.activatedAdvertisers$.subscribe((result) => {
      if (result) {
        this.activatedAdvertisers = result;
        this.activatedAdvertisers = result.map((advertiser) => {
          const fullName = `${advertiser.firstName} ${advertiser.lastName}`
            .trim()
            .toLowerCase();

          return {
            ...advertiser,
            fullName,
          };
        });
      }
    });
  }

  datesSelected(event: { startDate: Date | null; endDate: Date | null }) {
    this.form.controls["startingDate"].setValue(event.startDate);
    this.form.controls["endingDate"].setValue(event.endDate);
    const adDetailsWithNewDates: AdDetailsInterface = {
      ...this.adDetails,
      startDate: event.startDate,
      endDate: event.endDate,
    };
    if (event.startDate && event.endDate)
      this.newCampaignCalculatorService.onSelectCalculatePrice(
        adDetailsWithNewDates.startDate,
        adDetailsWithNewDates.endDate,
        adDetailsWithNewDates.objectiveName,
        adDetailsWithNewDates.calculationMethod,
        this.allSelectionsByMethod
      );
  }

  playAnimation() {
    let increasing = false;
    if (this.newTotalImpressionsMax > this.prevTotalImpressionsMax) {
      increasing = true;
      this.animating = true;
    }

    const minImpressionsStep = increasing
      ? Math.ceil(
          (this.newTotalImpressionsMin - this.prevTotalImpressionsMin) / 50
        )
      : Math.floor(
          (this.newTotalImpressionsMin - this.prevTotalImpressionsMin) / 50
        );

    const maxImpressionsStep = increasing
      ? Math.ceil(
          (this.newTotalImpressionsMax - this.prevTotalImpressionsMax) / 50
        )
      : Math.floor(
          (this.newTotalImpressionsMax - this.prevTotalImpressionsMax) / 50
        );

    const minClicksStep = increasing
      ? Math.ceil((this.newTotalClicksMin - this.prevTotalClicksMin) / 50)
      : Math.floor((this.newTotalClicksMin - this.prevTotalClicksMin) / 50);

    const maxClicksStep = increasing
      ? Math.ceil((this.newTotalClicksMax - this.prevTotalClicksMax) / 50)
      : Math.floor((this.newTotalClicksMax - this.prevTotalClicksMax) / 50);

    const minLeadsStep = increasing
      ? Math.ceil((this.newTotalLeadsMin - this.prevTotalLeadsMin) / 50)
      : Math.floor((this.newTotalLeadsMin - this.prevTotalLeadsMin) / 50);

    const maxLeadsStep = increasing
      ? Math.ceil((this.newTotalLeadsMax - this.prevTotalLeadsMax) / 50)
      : Math.floor((this.newTotalLeadsMax - this.prevTotalLeadsMax) / 50);

    this.animationInterval = setInterval(() => {
      this.totalImpressionsMin = increasing
        ? Math.min(
            this.totalImpressionsMin + minImpressionsStep,
            this.newTotalImpressionsMin
          )
        : Math.max(
            this.totalImpressionsMin + minImpressionsStep,
            this.newTotalImpressionsMin
          );

      this.totalImpressionsMax = increasing
        ? Math.min(
            this.totalImpressionsMax + maxImpressionsStep,
            this.newTotalImpressionsMax
          )
        : Math.max(
            this.totalImpressionsMax + maxImpressionsStep,
            this.newTotalImpressionsMax
          );

      this.totalClicksMin = increasing
        ? Math.min(this.totalClicksMin + minClicksStep, this.newTotalClicksMin)
        : Math.max(this.totalClicksMin + minClicksStep, this.newTotalClicksMin);

      this.totalClicksMax = increasing
        ? Math.min(this.totalClicksMax + maxClicksStep, this.newTotalClicksMax)
        : Math.max(this.totalClicksMax + maxClicksStep, this.newTotalClicksMax);

      this.totalLeadsMin = increasing
        ? Math.min(this.totalLeadsMin + minLeadsStep, this.newTotalLeadsMin)
        : Math.max(this.totalLeadsMin + minLeadsStep, this.newTotalLeadsMin);

      this.totalLeadsMax = increasing
        ? Math.min(this.totalLeadsMax + maxLeadsStep, this.newTotalLeadsMax)
        : Math.max(this.totalLeadsMax + maxLeadsStep, this.newTotalLeadsMax);

      if (
        this.totalImpressionsMin === this.newTotalImpressionsMin &&
        this.totalImpressionsMax === this.newTotalImpressionsMax &&
        this.totalClicksMin === this.newTotalClicksMin &&
        this.totalClicksMax === this.newTotalClicksMax &&
        this.totalLeadsMin === this.newTotalLeadsMin &&
        this.totalLeadsMax === this.newTotalLeadsMax
      ) {
        this.animating = false;
        clearInterval(this.animationInterval);
      }
    }, 15);
  }

  datesValidator(): boolean {
    return (
      (UtilFunctions.formValidator(this.form, "startingDate") &&
        UtilFunctions.formValidator(this.form, "endingDate")) ??
      false
    );
  }

  titleValidator(): boolean {
    return UtilFunctions.formValidator(this.form, "title");
  }

  searchByName(term: string, item: any) {
    if (!term) return true;

    const normalizedTerm = term.trim().toLowerCase();
    const fullName = `${item.firstName} ${item.lastName}`.trim().toLowerCase();

    return fullName.includes(normalizedTerm);
  }

}
